import axios from 'axios';
import {Dispatch} from 'redux';
import {receiveGroupStatusesFinished, receiveGroupStatusesStarted} from '../actions/GroupStatus';
import GroupStatus from '../models/GroupStatus';
import Utils from '../utils/Utils';
import AuthenticationService from './Authentication';


class GroupStatusService {
    public static receive = (): ((dispatch) => void) =>
        (dispatch: Dispatch): void => {
            dispatch(receiveGroupStatusesStarted());

            axios.get(Utils.generateApiUrl('group-statuses'), {
                headers: {
                    'Authorization': `Token ${AuthenticationService.getToken()}`,
                },
            })
                .then((response): void => {
                    dispatch(receiveGroupStatusesFinished(response.data as GroupStatus[]));
                })
                .catch(Utils.handleError);
        };
}

export default GroupStatusService;
